import { Account } from '../../auth';
import { ColumnModel, FilterModel } from '../../filter';

export const RoutineFilterKey = 'ROUTINE_FILTER';
export const RoutineOrderKey = 'ROUTINE_ORDER_KEY';

export const RoutineFilterColumns = [
  'assetsCount',
  'addonsCount',
  'submissionsCount',
  'groups',
  'groupNames',
  'lastSubmitted',
  'type',
  'allAssetsCount',
  'updatedAt',
  'createdAt',
];

export class RoutineFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  columns?: string[];
  workspaceId?: string;

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.workspaceId = data?.workspaceId;
    this.columns = data?.columns || [
      'assetsCount',
      'addonsCount',
      'submissionsCount',
      'groups',
      'groupNames',
      'lastSubmitted',
      'workspace',
    ];
  }
  public scrubWorkspaceData(): void {
    this.workspaceId = undefined;
  }

  public getColumnsCount(): number {
    return this.columns && this.columns.length > 0 ? this.columns.length : 0;
  }

  public getGraphQLFilter(): any {
    const filter = {} as any;

    if (this.keyword) {
      filter.keyword = this.keyword;
    }

    if (this.workspaceId) {
      filter.workspaceId = this.workspaceId;
    }

    return filter;
  }
}
